import DropdownIndicator from './DropdownIndicator.page';
import NoOptionsMessage from './NoOptionsMessage.page';
import LoadingMessage from './LoadingMessage.page';
import Control from './Control.page';
import Option from './Option.page';

export const Components = {
  IndicatorSeparator: () => null,
  DropdownIndicator,
  NoOptionsMessage,
  LoadingMessage,
  Control,
  Option
};
